import React from "react";

const WaitlistModal = ({
  showWaitlistModal,
  closeWaitlistModal,
  formData,
  handleInputChange,
  handleSubmit,
  isSubmitting,
  isSubmitted,
  formError,
}) => {
  if (!showWaitlistModal) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4 sm:p-6"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeWaitlistModal();
      }}
    >
      <div className="w-full max-w-lg bg-white border border-slate-900/10 rounded-2xl sm:rounded-3xl shadow-2xl shadow-slate-900/20 p-6 sm:p-7 relative max-h-[90vh] overflow-y-auto">
        <button
          onClick={closeWaitlistModal}
          className="absolute top-3 right-3 sm:top-4 sm:right-4 w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-slate-900/15 bg-slate-900/5 text-slate-900 text-xl flex items-center justify-center hover:bg-slate-900/10 transition-colors"
        >
          ×
        </button>

        {!isSubmitted ? (
          <>
            <h2 className="text-2xl sm:text-3xl tracking-tight font-black m-0 mb-2 sm:mb-2.5 text-slate-900 pr-8">
              Join the Jindo waitlist
            </h2>
            <p className="text-slate-600 leading-relaxed mt-2 sm:mt-2.5 mb-5 sm:mb-6 text-sm sm:text-base">
              Tell us a little about you. We'll reach out with next steps and
              early access details.
            </p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="grid gap-3 sm:gap-3.5">
                <label className="grid gap-1.5 sm:gap-2 text-slate-900 font-bold text-xs sm:text-[13px]">
                  <span>
                    Name{" "}
                    <span className="text-jindo-orange font-black ml-0.5">
                      *
                    </span>
                  </span>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    autoComplete="name"
                    className="w-full rounded-xl sm:rounded-[14px] border border-slate-900/15 bg-gray-50 text-slate-900 py-3 sm:py-3.5 px-3 sm:px-3.5 font-normal outline-none text-sm sm:text-base focus:border-jindo-orange/75 focus:ring-4 focus:ring-jindo-orange/10 transition-shadow"
                  />
                </label>
                <label className="grid gap-1.5 sm:gap-2 text-slate-900 font-bold text-xs sm:text-[13px]">
                  <span>
                    Work email{" "}
                    <span className="text-jindo-orange font-black ml-0.5">
                      *
                    </span>
                  </span>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    autoComplete="email"
                    className="w-full rounded-xl sm:rounded-[14px] border border-slate-900/15 bg-gray-50 text-slate-900 py-3 sm:py-3.5 px-3 sm:px-3.5 font-normal outline-none text-sm sm:text-base focus:border-jindo-orange/75 focus:ring-4 focus:ring-jindo-orange/10 transition-shadow"
                  />
                </label>
                <label className="grid gap-1.5 sm:gap-2 text-slate-900 font-bold text-xs sm:text-[13px]">
                  <span>Company</span>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    autoComplete="organization"
                    className="w-full rounded-xl sm:rounded-[14px] border border-slate-900/15 bg-gray-50 text-slate-900 py-3 sm:py-3.5 px-3 sm:px-3.5 font-normal outline-none text-sm sm:text-base focus:border-jindo-orange/75 focus:ring-4 focus:ring-jindo-orange/10 transition-shadow"
                  />
                </label>
              </div>
              {formError && (
                <div className="text-red-500 font-bold mt-3 text-xs sm:text-sm">
                  {formError}
                </div>
              )}
              <div className="flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-3 mt-4 sm:mt-5">
                <button
                  type="button"
                  onClick={closeWaitlistModal}
                  className="inline-flex items-center justify-center rounded-full border border-slate-900/20 bg-slate-900/5 text-slate-900 px-6 py-3 sm:py-3.5 font-black text-sm sm:text-[15px] leading-none hover:-translate-y-0.5 transition-transform"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="inline-flex items-center justify-center rounded-full border border-jindo-orange/80 bg-jindo-orange text-jindo-orange-950 px-6 py-3 sm:py-3.5 font-black text-sm sm:text-[15px] leading-none shadow-lg shadow-jindo-orange/20 hover:-translate-y-0.5 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center py-4 sm:py-6">
            <h2 className="text-2xl sm:text-3xl tracking-tight font-black m-0 mb-2 sm:mb-2.5 text-slate-900">
              Thanks for joining the journey.
            </h2>
            <p className="text-slate-600 leading-relaxed mt-2 sm:mt-2.5 mb-5 sm:mb-6 text-sm sm:text-base">
              Thanks for signing up! Our team will contact you soon with more
              details and help you start your Jindo journey.
            </p>
            <button
              onClick={closeWaitlistModal}
              className="inline-flex items-center justify-center rounded-full border border-jindo-orange/80 bg-jindo-orange text-jindo-orange-950 px-6 py-3 sm:py-3.5 font-black text-sm sm:text-[15px] leading-none shadow-lg shadow-jindo-orange/20 hover:-translate-y-0.5 transition-transform"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WaitlistModal;
